var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLooseBoulderStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#635C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.988 20.4127L33.9037 22.6167L26.6153 8L17.823 30.0267L14.0137 29.2627L11 35.3047L12.686 36.9947H41L34.988 20.4127ZM18.2963 30.9003L20.8333 31.409L21.9237 34.6897L17.221 33.5113L15.0527 30.25L17.9773 30.8367L18.2963 30.9003ZM14.272 30.4553L16.456 33.74L12.8933 36.121L11.9287 35.154L14.272 30.4553ZM14.103 36.231L17.0563 34.2573L21.76 35.4357L20.967 36.231H14.103ZM22.9423 35.3323L21.418 30.7473L18.5843 30.1793L26.6923 9.86667L33.4793 23.4783L30.4513 29.6323L31.1367 29.9697L34.8813 22.3593L39.9107 36.2313H22.046L22.9423 35.3323Z",
    fill: "#F6F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.645 9.34907L31.9188 9.11279L31.3142 10.9712L32.0403 11.2074L32.645 9.34907Z",
    fill: "#F6F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9226 12.3641L34.9268 11.4207L34.6017 10.7301L32.5975 11.6734L32.9226 12.3641Z",
    fill: "#F6F8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6688 14.5303L34.906 13.8047L33.0481 13.1972L32.8109 13.9228L34.6688 14.5303Z",
    fill: "#F6F8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1102 26.6313L11.7267 25.2509L11.1873 25.7915L12.5708 27.1719L13.1102 26.6313Z",
    fill: "#F6F8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6067 24.1427H13.843V26.4447H14.6067V24.1427Z",
    fill: "#F6F8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2607 25.791L16.7208 25.2509L15.3387 26.6326L15.8786 27.1727L17.2607 25.791Z",
    fill: "#F6F8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooseBoulderStructure);
export default __webpack_public_path__ + "static/media/Loose_boulder_structure.1b6af9e9591f18e8578582bb43db4d63.svg";
export { ForwardRef as ReactComponent };